<template>
  <!-- Change viewBox and fill params -->
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 32 32"
  >
    <g>
      <path
        fill="#4365e2"
        d="M16.008 7.795c-4.531 0-8.204 3.673-8.204 8.204s3.673 8.204 8.204 8.204c4.531 0 8.204-3.673 8.204-8.204v0c0-0.004 0-0.009 0-0.014 0-4.524-3.667-8.191-8.191-8.191-0.005 0-0.009 0-0.014 0h0.001zM16.008 21.333c-2.946 0-5.334-2.388-5.334-5.334s2.388-5.334 5.334-5.334c2.946 0 5.334 2.388 5.334 5.334v0c-0.005 2.944-2.39 5.329-5.334 5.334h-0zM26.461 7.459c0 1.057-0.857 1.913-1.913 1.913s-1.913-0.857-1.913-1.913c0-1.057 0.857-1.913 1.913-1.913v0c0.001 0 0.003 0 0.005 0 1.054 0 1.909 0.855 1.909 1.909 0 0.002 0 0.003 0 0.005v-0zM31.894 9.397c0.001-0.060 0.002-0.131 0.002-0.202 0-2.52-0.985-4.811-2.59-6.507l0.004 0.004c-1.701-1.601-3.999-2.586-6.527-2.586-0.063 0-0.125 0.001-0.187 0.002l0.009-0c-2.642-0.151-10.561-0.151-13.203 0-0.055-0.001-0.12-0.002-0.185-0.002-2.525 0-4.821 0.983-6.525 2.588l0.005-0.005c-1.601 1.697-2.586 3.991-2.586 6.515 0 0.068 0.001 0.135 0.002 0.202l-0-0.010c-0.151 2.642-0.151 10.561 0 13.203-0.001 0.060-0.002 0.131-0.002 0.202 0 2.52 0.985 4.811 2.59 6.507l-0.004-0.004c1.703 1.6 4.001 2.583 6.529 2.583 0.060 0 0.12-0.001 0.18-0.002l-0.009 0c2.642 0.151 10.561 0.151 13.203 0 0.060 0.001 0.131 0.002 0.202 0.002 2.52 0 4.811-0.985 6.507-2.59l-0.004 0.004c1.602-1.701 2.586-3.999 2.586-6.527 0-0.063-0.001-0.125-0.002-0.187l0 0.009c0.155-2.642 0.155-10.554 0.005-13.201zM28.482 25.428c-0.561 1.395-1.646 2.48-3.005 3.028l-0.036 0.013c-2.133 0.459-4.584 0.721-7.096 0.721-0.822 0-1.638-0.028-2.447-0.084l0.109 0.006c-0.693 0.048-1.503 0.076-2.318 0.076-2.519 0-4.976-0.262-7.346-0.76l0.232 0.041c-1.395-0.561-2.48-1.646-3.028-3.005l-0.013-0.036c-0.459-2.133-0.721-4.584-0.721-7.096 0-0.822 0.028-1.638 0.084-2.447l-0.006 0.109c-0.048-0.693-0.076-1.503-0.076-2.318 0-2.519 0.262-4.976 0.76-7.346l-0.041 0.232c0.561-1.395 1.646-2.48 3.005-3.028l0.036-0.013c2.133-0.459 4.584-0.721 7.096-0.721 0.822 0 1.638 0.028 2.446 0.084l-0.109-0.006c0.693-0.048 1.503-0.076 2.318-0.076 2.519 0 4.976 0.262 7.346 0.76l-0.232-0.041c1.395 0.561 2.48 1.646 3.028 3.005l0.013 0.036c0.459 2.133 0.721 4.584 0.721 7.096 0 0.822-0.028 1.638-0.084 2.446l0.006-0.109c0.050 0.701 0.078 1.518 0.078 2.342 0 2.512-0.263 4.963-0.762 7.326l0.041-0.23z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: ''
    },
    height: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: ''
    }
  }
}
</script>
